const CONFIG = {
  RELEASE: {
    VERSION: "beta",
    NAME: "Testing"
  },
  N : 30,
  SPECTRUM: [
    "rgb(176,212,243)",
    "rgb(128,186,236)",
    "rgb(77,158,228)",
    "rgb(38,137,223)",
    "rgb(0,116,217)",
    "rgb(0,106,197)"
  ],
  
  APPLICATION: {
    PACKAGES: [
      {
        name: "Free",
        fullName: "Free",
        order: 1,
        price: "$0",
        cycle: "guests",
        purchased: true
      },
      {
        name: "Individual",
        fullName: "Individual Plan",
        order: 2,
        price: "$10",
        cycle: "early access",
        purchased: false
      },
      // {
      //   name: "Institution Plan",
      //   order: 3,
      //   price: "Contact",
      //   purchased: false,
      //   action: 'Contact Us'
      // }
    ],
    FEATURES: [
      {
        title: "General career options.",
        description: "The basic career options",
        tier: ["free", "individual", "institution"],
        enable: true
      }, 
      {
        title: "Extensive career catalog.",
        description: "Full access to our growing list of career options.",
        tier: ["individual", "institution"],
        enable: true
      },
      {
        title: "Career recommendations.",
        description: "Use your personal data to provide career recommendations.",
        tier: ["free", "individual", "institution"],
        enable: true
      },
      {
        title: "Bonus tips on career path.",
        description: "Additional tips of how you can get ahead.",
        tier: ["individual", "institution"],
        enable: true
      },
      {
        title: "Career webinar.",
        description: "Access to pre-recorded webinars with experts and other presentations.",
        tier: [ "individual", "institution"],
        enable: false
      },
      {
        title: "Early access to beta features.",
        description: "As we improve our product, you'll be notified of the benefits.",
        tier: ["individual", "institution"],
        enable: true
      },
      {
        title: "Share basic summary on social media.",
        description: "Share basic pathways on your social media account.",
        tier: ["free", "individual", "institution"],
        enable: true
      },
      {
        title: "Share full profile with career coach.",
        description: "Share your personality test results and other pathways with your career coach.",
        tier: ["individual","institution"],
        enable: true
      }
    ],
    FEEDBACK: {
      WIDGET_ID: "4080200b-6fbc-459b-ae2e-437611b962f8"
    },
    META_DATA : {
      TITLE: "Your IdealCareerPath",
      DESCRIPTION: ""
    },
    AUTH: {
      SESSION_NAME: "icp",
      FB_USER_ROOT_PATH: "/user-data",
      REDIRECT_PATH: "/auth"
    },
    DECISION: {
      ROOT: "decisions"
    },
    URL: {
      AUTH: "/auth",
      DECISION: "/start",
      DASHBOARD: "/path",
      WELCOME: "/welcome",
      SUMMARY: "/summary",
      COOKIE_POLICY: "/cookie-policy",
      PRICING: "/pricing",
      PARAMS: {
        REDIRECT_TO: "rdt",
        CHOICE: "cd",
        LEVEL: "l",
        SUMMARY_ID: "sid",
        AUTO_LOGOUT: "alo"
      },
      SOCIAL_MEDIA: {
        TWITTER: "https://twitter.com/ICareerpath",
        FACEBOOK: "https://www.facebook.com",
        INSTAGRAM: "https://www.instagram.com/idealcareerpath"
      }
    },
    PATHS: {
      ROOT: "paths",
      SUMMARY: "summary",
      DEFAULT: "default",
      PAYMENT: "payment",
      PRICING: "pricing",
      // TODO: Update this list when a new career path comes on board. 
      ALLOWED_PATHS: [
        "business",
        "health",
        "information-technology",
        "engineering"
      ]
    },
    NODES : {
      DEFAULT: {
        RIGHT_NODE: "Right Node",
        LEFT_NODE: "Left Node",
        START_NODE: "start"  
      }
    },
    ADDITIONAL: {
      SAVE_SESSION_NAME : "ssd",
      COOKIE_NAME: "ccicp",
      P_PLAN: "pp",
      MODAL_SELECTION_PARENT: "div.modal-container",
      CONTACT_US: "https://forms.gle/pPnp4NSagHA9gCPy6",
      DECISION_CACHE_NAME: "dc"
    },
    ANALYTICS: {
      LOG_PARAM : "cc_param",
      SCREENS: {
        STEP_DETAILS: "step",
        DECISION: "decision",
        AUTHENTICATION: "auth",
        SUMMARY: "summary",
        PATHWAY: "path",
        FEEDBACK: "feedback",
        PRICING: "pricing",
        PAYMENT_START: "pricing",
        PAYMENT_CONFIRM: "pconfirm"
      },
      ACTIONS: {
        STEP: "step",
        CLOSE: "close",
        OPEN: "open",
        COMPLETE: "complete",
        RANDOM: "idk",
        PREVIOUS: "prev",
        NEXT: "next",
        MOTIVATOR: "motivator"
      },
      GTAG_EVENTS: {
        PAGE_VIEW: "page_view",
        SELECTED_CONTENT: "select_content"
      },
      GTAG_PARAMS: {
        CONTENT_TYPE: "content_type",
        ITEM_ID: "item_id"
      }
    }
  }
}

export default CONFIG;
